import { Dispatch, SetStateAction, useCallback, useState } from 'react';
import { NavigateOptions, To, useLocation, useNavigate } from 'react-router-dom';
import { isEqual } from 'lodash';

import { ILocationState } from 'types';

// for not re-render component if state was not changed
export const useMemoState = <T>(defState?: T | (() => T)): [T | undefined, Dispatch<SetStateAction<T | undefined>>] => {
  const [state, setState] = useState(defState);

  const smartSetState = useCallback((newState: SetStateAction<T | undefined>) => {
    const areEqual = isEqual(state, newState);

    if (!areEqual) {
      setState(newState);
    }
  }, [state]);

  return [state, smartSetState];
};

export const useRedirect = () => {
  const navigate = useNavigate();

  const onRedirect = useCallback((path: To | number, options?: NavigateOptions) => () => {
    navigate(path as To, options);
  }, []);

  return onRedirect;
};

export const useTypedLocation = <S>() => {
  const { pathname, search, state } = useLocation();

  return {
    search,
    pathname,
    state: state as (S & ILocationState) | undefined,
  };
};
